// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Ll3Il","modalFooterButton":"ModalNotes_modalFooterButton__3b8ti"};